import {useState} from 'react'
import {useIntersectionObserver} from './use-intersection-observer'

const DEFAULT_OPTIONS: IntersectionObserverInit = {
  root: null,
  rootMargin: '0px',
  threshold: [0, 1],
}

/**
 * Hook that detects whether a sensor element has scrolled out of view,
 * indicating a sticky header should be in its "stuck" state.
 *
 * Returns a callback ref (`sensorRef`) that should be placed on a sentinel
 * element at the sticky attachment point.
 *
 * @param observerOptions  Optional IntersectionObserver options override
 */
export function useStickyHeader(observerOptions: IntersectionObserverInit = DEFAULT_OPTIONS) {
  const [isSticky, setIsSticky] = useState(false)
  const [hasRoots, setHasRoots] = useState(false)

  const sensorRef = useIntersectionObserver(entries => {
    const entry = entries[entries.length - 1]
    if (entry) {
      setIsSticky(entry.intersectionRatio < 1)
      setHasRoots((entry.rootBounds?.height ?? 0) > 0)
    }
  }, observerOptions)

  return {isSticky, hasRoots, sensorRef}
}
